import { isWx } from "./index";

/**
 * 打开APP或跳转到应用商店
 * @param {Object} params 传递给APP的参数
 * @param {string} path APP内的路径
 */
export const openApp = (params = {}) => {
  // if (isWx()) {
  //   return;
  // }
  try {
    ULink([
      {
        id: "usr11k03rqrdggn7",
        data: { ...ULink.getUriParams(), ...params },
        auto: true,
        timeout: 2000,
        selector: "#wakeup-btn",
        useOpenInBrowerTips: "default",
        useLoading: true,
        useClipboard: true,
        proxyOpenDownload: function (defaultAction, LinkInstance) {
          if (LinkInstance.solution.type === "scheme") {
            // qq或者微信环境特殊处理下
            if (ULink.isWechat || ULink.isQQ) {
              // 在qq或者微信环境执行内置逻辑，具体内置逻辑为:当设置了useOpenInBrowerTips字段时，qq&&微信&&scheme时，启用蒙层提示去浏览器打开
              defaultAction();
            } else {
              location.href = LinkInstance.solution.downloadUrl;
            }
          } else if (LinkInstance.solution.type === "universalLink") {
            // universalLink 唤起应当由服务端提供一个带重定向到appstore的universallink地址。因此，此处不应写逻辑，友盟会在近期上线universalLink 重定向功能。
          }
        },
      },
    ]);
  } catch (error) {
    console.error(error);
  }
};

export default {
  openApp,
};
